import { Row, Col, Modal, Form, Button, Spinner, OverlayTrigger, Popover } from "react-bootstrap"
import { useEffect, useState } from "react";
import { IAppState } from '../../../../../../redux/storeTypes';
import { connect, useDispatch } from "react-redux";
import Table from '../../../../../../components/Table';
import FormHeader from "../../../../../../components/layout/FormHeader";
import CurrencyInput from '../../../../../../components/currency/CurrencyInput';
import { CurrencyFormatter } from "../../../../../../components/Formatters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faInfoCircle, faTimesCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { updateOrderDetailsAction, updateShoppingCart } from "../../../../../../redux/actions/orderManagement";
import { sendSuccessToastAction } from "../../../../../../redux/actions/toast";
import { Order } from "../../../../../../models/Order";
import { DateFormatter } from "./ForsythSearchResults";
import _ from "lodash";

export const PAYABLE_METADATA_KEY = 'PayableOnline';

interface IThreeRiversSearchResults {
    billNumberLabel: string,
    nameLabel: string,
    dueDateLabel: string,
    amountDueLabel: string,
    paymentOptionsLabel: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText: string,
    minimumPaymentErrorText: string,
    allowOverpayment: boolean,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    margin: string,
    padding: string,
    headerBackgroundColor: string,
    headerPadding: string,
    itemDetails: any,
    order?: any,
    shoppingCart?: any,
    isFetching: boolean,
    itemSearchDetails?: any
}

export const BILL_NUMBER_LABEL = 'Bill Number';
export const NAME_LABEL = 'Name';
export const DUE_DATE_LABEL = 'Due Date';
export const AMOUNT_DUE_LABEL = 'Amount Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const MINIMUM_PARTIAL_PAYMENT_AMOUNT = 0;
export const MINIMUM_PAYMENT_TEXT = 'Minimum partial payment: {amount}';
export const MINIMUM_PAYMENT_ERROR_TEXT = 'Partial payments must be at least {amount}';
export const ALLOW_OVERPAYMENT = true;
export const OVERLAY_TEXT = "I'm sorry. Your bill is not currently payable online, please call us at 1-800-253-0831 or visit our office for further assistance.";
export const OVERLAY_BACKGROUND = '#fef1b5';
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const NO_MATCH_FOUND_TEXT = 'NO MATCH FOUND';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

export const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const ThreeRiversSearchResults = ({ billNumberLabel, nameLabel, dueDateLabel, amountDueLabel, paymentOptionsLabel,
    minimumPartialPaymentAmount, minimumPaymentText, minimumPaymentErrorText, allowOverpayment, itemSearchDetails,
    overlayText, overlayBackground, overlayTextColor, overlayIconColor, noMatchFoundText, margin, padding, headerBackgroundColor, headerPadding,
    itemDetails, shoppingCart, order, isFetching }: IThreeRiversSearchResults) => {

    if (!billNumberLabel) { billNumberLabel = BILL_NUMBER_LABEL }
    if (!nameLabel) { nameLabel = NAME_LABEL }
    if (!dueDateLabel) { dueDateLabel = DUE_DATE_LABEL }
    if (!amountDueLabel) { amountDueLabel = AMOUNT_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (minimumPartialPaymentAmount == null) { minimumPartialPaymentAmount = MINIMUM_PARTIAL_PAYMENT_AMOUNT }
    if (!minimumPaymentText) { minimumPaymentText = MINIMUM_PAYMENT_TEXT }
    if (!minimumPaymentErrorText) { minimumPaymentErrorText = MINIMUM_PAYMENT_ERROR_TEXT }
    if (allowOverpayment == null) { allowOverpayment = ALLOW_OVERPAYMENT }
    if (!overlayText) { overlayText = OVERLAY_TEXT }
    if (!overlayBackground) { overlayBackground = OVERLAY_BACKGROUND }
    if (!overlayTextColor) { overlayTextColor = OVERLAY_TEXT_COLOR }
    if (!overlayIconColor) { overlayIconColor = OVERLAY_ICON_COLOR }
    if (!noMatchFoundText) { noMatchFoundText = NO_MATCH_FOUND_TEXT }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }

    const [amount, setAmount] = useState<any>();
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState<any>({ option: 'full' });
    const [cartErrorMessage, setCartErrorMessage] = useState<string>('');

    const amountFormatter = (cell: any) => {
        return (<span>{formatter.format(cell)}</span>)
    }

    const openPaymentOptions = (row: any) => {
        setSelectedRow(row);
        setCartErrorMessage('');
        setSelectedOption({ option: Number(row?.metaData?.TotalDue) > 0 ? 'full' : 'partial' });
        setAmount(null);
        setShowModal(true);
    }

    const paymentOptionsFormatter = (cell: any, row: any) => {
        if (row?.metaData?.[PAYABLE_METADATA_KEY] != false) {
            return (
                <span>
                    <a onClick={() => openPaymentOptions(row)}>
                        {paymentOptionsLabel}
                    </a>
                </span>
            )
        }
        else {
            return (
                <span style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <OverlayTrigger trigger="click" rootClose placement="top" overlay={(
                        <Popover id="popover-positioned-top" style={{ backgroundColor: overlayBackground, color: overlayTextColor, minWidth: '400px' }}>
                            <Popover.Content>
                                <div style={{ display: 'flex', alignItems: 'center', columnGap: '8px', fontSize: 'medium' }}>
                                    <FontAwesomeIcon icon={faExclamationTriangle} color={overlayIconColor} className="btn-icon" />
                                {overlayText}
                                </div>
                            </Popover.Content>
                        </Popover>
                    )}>
                        <FontAwesomeIcon icon={faInfoCircle} className="btn-icon" style={{ color: "#6495ed", cursor: 'pointer' }} />
                    </OverlayTrigger>
                </span>
            )
        }
    }

    const initialColumns = [{
        dataField: 'metaData.AccountNumber',
        text: billNumberLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'metaData.BillToName',
        text: nameLabel,
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'metaData.DueDate',
        text: dueDateLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
        formatter: DateFormatter,
    }, {
        dataField: 'metaData.TotalDue',
        text: amountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: amountFormatter,
        sort: true,
    }, {
        dataField: 'metaData.ReferenceNumber',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: paymentOptionsFormatter
    }];

    const [columns, setColumns] = useState<any>(initialColumns);
    const [data, setData] = useState<any>([]);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [showModal, setShowModal] = useState<boolean>(false);

    const amountDue = Number(selectedRow?.metaData?.TotalDue) || 0;
    const hasAmountDue = amountDue > 0;
    const withMinimumAmount = (text: string) => text.split('{amount}').join(formatter.format(minimumPartialPaymentAmount));

    const mappingDetails = [
        { heading: billNumberLabel, value: selectedRow?.metaData?.AccountNumber },
        { heading: nameLabel, value: selectedRow?.metaData?.BillToName },
        { heading: dueDateLabel, value: DateFormatter(selectedRow?.metaData?.DueDate, selectedRow) },
        { heading: amountDueLabel, value: CurrencyFormatter(amountDue) },
    ]

    const handleRadioSelect = (e: any) => {
        setCartErrorMessage('');
        setSelectedOption({ option: e.target.id });
        setAmount(null)
    }

    const partialAmountChange = (value: any) => {
        if (!allowOverpayment && hasAmountDue && value > amountDue) {
            setCartErrorMessage('Amounts cannot be greater than total due')
            setAmount(null)
            return
        }
        if (value > 0 && value < minimumPartialPaymentAmount) {
            setCartErrorMessage(withMinimumAmount(minimumPaymentErrorText))
            setAmount(value)
            return
        }
        setCartErrorMessage('')
        setAmount(value)
    }

    useEffect(() => {
        setData(itemDetails ?? []);
    }, [itemDetails])

    const hasSearched = itemSearchDetails != null;

    const renderTable = () => {
        if (isFetching) {
            return (<div style={{ textAlign: 'center' }} ><Spinner animation="border" /> </div>);
        }
        else if (data.length === 0 && hasSearched) {
            return (<div>{noMatchFoundText}</div>)
        }
        else if (data.length === 0) {
            return (<div>Please do a search to find the bill you are looking for.</div>)
        } else {
            return (
                <>
                    <Table
                        keyField="msbId"
                        data={data}
                        remote={false}
                        columns={columns}
                        sizePerPage={5}
                    />
                </>);
        }
    };

    const inCart = shoppingCart?.some((cart: any) => cart?.id === selectedRow?.metaData?.ReferenceNumber);

    const paymentAmount = selectedOption?.option === 'partial' ? _.toNumber(amount) : amountDue;

    const isPartialAmountInvalid = selectedOption?.option == 'partial' && (amount == undefined || amount == 0
        || (!allowOverpayment && hasAmountDue && amount > amountDue)
        || amount < minimumPartialPaymentAmount);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const shoppingCartObject = [
            {
                billNumber: selectedRow?.metaData?.AccountNumber,
                name: selectedRow?.metaData?.BillToName,
                dueDate: selectedRow?.metaData?.DueDate,
                id: selectedRow?.metaData?.ReferenceNumber,
                paymentAmount: paymentAmount,
            }];
        const OrderLinesObject = [
            {
                accountNumber: selectedRow?.metaData?.AccountNumber,
                itemReferenceNumber: selectedRow?.metaData?.ReferenceNumber,
                quantity: 1,
                unitPrice: paymentAmount,
                itemMetadata: {
                    uiReferenceId: selectedRow?.metaData?.ReferenceNumber,
                    itemMsbid: selectedRow?.msbId,
                    AccountNumber: selectedRow?.metaData?.AccountNumber
                },
                itemName: selectedRow?.metaData?.AccountNumber,
            }];
        if (order) {
            const updatedOrderLines = order?.orderLines.filter((orderLine: any) => !OrderLinesObject.some((selected: any) => orderLine?.itemMetadata?.uiReferenceId === selected?.itemMetadata?.uiReferenceId)).concat(OrderLinesObject);
            const updatedShoppingCart = shoppingCart.filter((cart: any) => !shoppingCartObject.some((selected: any) => cart?.id === selected?.id)).concat(shoppingCartObject);
            order.methodName = "Sale";
            order.orderLines = updatedOrderLines;
            dispatch(updateShoppingCart(updatedShoppingCart, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(order, 'actionToken'));
        }
        else {
            let _order = new Order();
            _order.methodName = "Sale";
            _order.orderLines = OrderLinesObject;
            dispatch(updateShoppingCart(shoppingCartObject, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(_order, 'actionToken'));
        }
        dispatch(sendSuccessToastAction('Added to cart'))
        setShowModal(false);
    }

    return (

        <div style={{ margin: margin, padding: padding }}>
            <Row><Col>{renderTable()}</Col></Row>
            <Modal show={showModal} size={'lg'} backdrop="static" onHide={() => setShowModal(false)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <FormHeader title="Bill Details" description={"Below are the selected bill details"} />
                    <Form.Group controlId="printTerminal" >
                        <>
                            {Object.entries(mappingDetails).map(
                                ([index, selectedArray]: any) => {
                                    return (
                                        <div key={index} className="neric_details_row">
                                            <h3>{selectedArray.heading}</h3>
                                            <span>{selectedArray.value}</span>
                                        </div>
                                    )
                                }
                            )}
                        </>
                    </Form.Group>
                    <hr />
                    {!inCart ?
                        <>
                            <FormHeader title="Payment Options" description={"Please select the following payment options"} />
                            <Form.Group controlId="paymentOptions">
                                <div className='stCharles_cart'>
                                    {hasAmountDue &&
                                        <>
                                            <div className='box'>
                                                <label>
                                                    <input
                                                        type='radio'
                                                        name='paymentOption'
                                                        className='neric_input'
                                                        id='full'
                                                        onChange={handleRadioSelect}
                                                        checked={selectedOption?.option === 'full'}
                                                    />
                                                    Total Due
                                                </label>
                                                <span className='box_span'>{formatter.format(amountDue)}</span>
                                            </div>
                                            <br />
                                        </>
                                    }
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='partial'
                                                onChange={handleRadioSelect}
                                                checked={selectedOption?.option === 'partial'}
                                            />Payment Amount
                                        </label>
                                        <Form.Group controlId="amount" className='box_span'>
                                            <CurrencyInput
                                                required
                                                className="form-control"
                                                id="summaryAmount"
                                                name="summaryAmount"
                                                placeholder="$ 0.00"
                                                maxLength={10}
                                                decimalsLimit={2}
                                                prefix="$ "
                                                disabled={selectedOption?.option != 'partial'}
                                                value={amount}
                                                onValueChange={(value: any) => partialAmountChange(value)}
                                            />
                                        </Form.Group>
                                        {selectedOption?.option === 'partial' && minimumPartialPaymentAmount > 0 &&
                                            <div style={{ fontSize: 'smaller', color: '#414141' }}>
                                                {withMinimumAmount(minimumPaymentText)}
                                            </div>
                                        }
                                        {cartErrorMessage && selectedOption?.option === 'partial' &&
                                            <div role="alert" id="paymentErrorBox" style={{ color: 'red' }}>
                                                <FontAwesomeIcon icon={faTimesCircle} color='red' /> {cartErrorMessage}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form.Group>
                        </>
                        :
                        <div className="stCharles-accordion accordion">
                            <div className='card'>
                                <div className='agreement_toggle_header card-header' style={{ justifyContent: 'center' }}>
                                    <FontAwesomeIcon color='green' icon={faCartPlus} />Added to cart
                                </div>
                            </div>
                        </div>
                    }
                    <Form.Group className="form-footer">
                        <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button type="submit"
                            disabled={inCart || isPartialAmountInvalid || !(paymentAmount > 0)} onClick={(e) => handleSubmit(e)}
                        >
                            {`Add to cart`}
                        </Button>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state: IAppState) => {
    return {
        isFetching: state.account.isFetching,
        itemDetails: state.account.itemDetails,
        shoppingCart: state.orderManagement.shoppingCart,
        order: state.orderManagement.order,
        itemSearchDetails: state.orderManagement.itemSearchDetails
    };
};

export default connect(mapStateToProps)(ThreeRiversSearchResults);
